import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import styles from "./styles.m.css";
import { Link } from "@quintype/components";
import Icon from "../../../atoms/icon";

const Menus = ({ items, onMegaMenuToggle, isMegaMenuOpen, itemCount = 11 }) => {
  const primaryHostUrl =
    global && global.location && global.location.origin ? global.location.origin : "https://www.vikatan.com";

  const isExcludedDomain =
    global &&
    global.location &&
    (global.location.hostname.startsWith("sports.vikatan.com") ||
      global.location.hostname.startsWith("cinema.vikatan.com"));

  let menus = items
    .filter(item => item.title && item.path)
    .slice(0, itemCount)
    .map(item => {
      console.log("item", item);
      const externalLink = item.isExternalLink ? item.path : null;
      const iconType = get(item, ["data", "icon-code"]) || "news";
      const subMenu = get(item, ["items"], []);
      const color = get(item, ["data", "color"]);
      const isElectionMenu =
        item.path.includes("tamil-nadu-assembly-election-2026") ||
        item.url.includes("tamil-nadu-assembly-election-2026");

      const modifyUrlOrPath = originalValue =>
        !isExcludedDomain && originalValue.startsWith("https://www.vikatan.com/")
          ? originalValue.replace("https://www.vikatan.com", primaryHostUrl)
          : originalValue;

      const modifiedUrl = modifyUrlOrPath(item.url);
      const modifiedPath = modifyUrlOrPath(item.path);

      return (
        <li
          itemProp="name"
          role="menuitem"
          key={item.id}
          className={`${styles["menu-item"]} ${styles["border-top"]} ${
            isElectionMenu ? styles["election-menu-item"] : ""
          }`}
        >
          {modifiedUrl === "https://www.vikatan.com/vikatan-play" ||
          modifiedUrl === "https://www.anandavikatan.com/vikatan-play" ||
          modifiedUrl === "https://www.vikatan.com/tamil-nadu-assembly-election-2026" ? (
            <a
              itemProp="url"
              aria-label={`Read More about ${item.title}`}
              className={`${styles["menu-item-link"]} ${isElectionMenu ? styles["election-menu-link"] : ""}`}
              href={`${modifiedUrl || modifiedPath}?pfrom=header-menu`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon type={iconType} className={styles.icon} />
              {item.title} {color === "#00000F" && <span className={styles["new-menu"]}>New</span>}
            </a>
          ) : (
            <Link
              itemprop="url"
              aria-label={`${"Read More about"} ${item.title}`}
              className={`${styles["menu-item-link"]} ${isElectionMenu ? styles["election-menu-link"] : ""}`}
              href={`${modifiedUrl || modifiedPath}?pfrom=header-menu`}
              externalLink={externalLink}
            >
              <Icon type={iconType} className={styles.icon} />
              {item.title} {color === "#00000F" && <span className={styles["new-menu"]}>New</span>}
            </Link>
          )}
          {subMenu.length > 0 && (
            <ul className={styles["sub-menu"]}>
              {subMenu.map(subitem => (
                <li key={subitem.id} className={styles["sub-menu-item"]}>
                  <Link
                    aria-label={`${"Read More about"} ${subitem.title}`}
                    className={styles["sub-menu-link"]}
                    href={`${subitem.path || subitem.url}?pfrom=header-submenu`}
                    externalLink={subitem.isExternalLink && subitem.path}
                    target={
                      subitem.path === "https://english.vikatan.com/" ||
                      subitem.path === "https://hindi.vikatan.com/" ||
                      subitem.path === "https://telugu.vikatan.com/"
                        ? "_blank"
                        : ""
                    }
                  >
                    {subitem.title}
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </li>
      );
    });
  return (
    <ul
      itemScope
      id="topnav"
      itemType="https://schema.org/SiteNavigationElement"
      role="menu"
      className={`${styles.menus}`}
    >
      {menus}
      <li
        className={`${styles["menu-item"]} ${styles["navbar-megamenu-toggle"]} show-tablet-and-desktop`}
        role="menuitem"
      >
        <button aria-label="toggle" role="button" className={styles["menu-item-link"]} onClick={onMegaMenuToggle}>
          {isMegaMenuOpen ? <Icon type={"menu-search"} /> : <Icon type={"menu-search"} />}
        </button>
      </li>
    </ul>
  );
};

Menus.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      path: PropTypes.string
    })
  ),
  onMegaMenuToggle: PropTypes.func,
  isMegaMenuOpen: PropTypes.bool,
  itemCount: PropTypes.number
};

const NavMenubar = ({ menuGroup, isMegaMenuOpen, onMegaMenuToggle, onSearchToggle, searchButtonRef }) => {
  const items = get(menuGroup, ["items"], null);
  if (!items || !items.length) {
    return null;
  }
  return (
    <nav className={`${styles.navbar} ${isMegaMenuOpen ? "show-tablet-and-desktop" : ""}`}>
      <div className={`container ${styles["navbar-inner-wrap"]}`}>
        <Menus items={items} onMegaMenuToggle={onMegaMenuToggle} isMegaMenuOpen={isMegaMenuOpen} />
      </div>
    </nav>
  );
};

NavMenubar.propTypes = {
  menuGroup: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    slug: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        title: PropTypes.string,
        path: PropTypes.string,
        items: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.number,
            title: PropTypes.string,
            path: PropTypes.string
          })
        )
      })
    )
  }),
  isMegaMenuOpen: PropTypes.bool,
  onMegaMenuToggle: PropTypes.func,
  onSearchToggle: PropTypes.func,
  searchButtonRef: PropTypes.func
};

export default NavMenubar;
